import React, {useCallback} from 'react'
import {defineMessages} from 'react-intl'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'

import {ReviewSortingDesktop} from './ReviewSortingDesktop'
import {ReviewSortingMobile} from './ReviewSortingMobile'
export const sortList = [
  {
    key: 'mostRelevant',
    value: 'relevancy'
  },
  {
    key: 'newestFirst',
    value: 'recency'
  },
  {
    key: 'highestScores',
    value: 'rating_desc'
  },
  {
    key: 'lowestScores',
    value: 'rating_asc'
  }
]

export const sortLabels = defineMessages({
  newestFirst: {
    id: 'reviews.newestFirst',
    defaultMessage: 'Newest first'
  },
  mostRelevant: {
    id: 'reviews.mostRelevant',
    defaultMessage: 'Most relevant'
  },
  lowestScores: {
    id: 'reviews.lowestScores',
    defaultMessage: 'Lowest scores'
  },
  highestScores: {
    id: 'reviews.highestScores',
    defaultMessage: 'Highest scores'
  }
})

interface Props {
  onChange: (value: string) => void
}

export const ReviewSorting: React.FC<Props> = ({onChange}) => {
  const {isDesktop} = useDeviceLayout()

  const handleSortSelect = useCallback(
    (value: string) => {
      onChange(value)
    },
    [onChange]
  )

  if (isDesktop) {
    return <ReviewSortingDesktop onSortChange={handleSortSelect} />
  }

  return <ReviewSortingMobile onSortChange={handleSortSelect} />
}
